function createOverlay(image, onInsert) {
  const transitionDuration = 150;
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);
  overlay.style.setProperty('--transition-duration', `${transitionDuration}ms`);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
    if (onInsert) onInsert();
  };

  return { overlay, transitionDuration };
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'transparent';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner?.classList.toggle('hidden');
}

function positionOverlay(image, event, zoomRatio, target) {
  const ratio = image.height / image.width;
  const imageRect = image.getBoundingClientRect();
  const xPosition = event.clientX - imageRect.left;
  const yPosition = event.clientY - imageRect.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  target.style.setProperty('--bg-position', `${xPercent} ${yPercent}`);
  target.style.setProperty('--bg-size', `${image.width * zoomRatio}px`);
}

function enableZoomOnClick(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-click');
  images.forEach((image) => {
    image.onclick = (event) => {
      const { overlay, transitionDuration } = createOverlay(image, () => {
        requestAnimationFrame(() => {
          overlay.style.setProperty('--bg-size', `${image.width * zoomRatio}px`);
        });
      });

      overlay.classList.add('image-magnify-full-size--animate');
      positionOverlay(image, event, zoomRatio, overlay);
      overlay.style.setProperty('--bg-size', '100%');

      function dismissOverlay() {
        overlay.style.setProperty('--bg-size', '100%');
        overlay.onclick = null;
        overlay.onmousemove = null;
        overlay.onmouseleave = null;
        setTimeout(() => overlay.remove(), transitionDuration);
      }

      overlay.onclick = dismissOverlay;
      overlay.onmousemove = (e) => positionOverlay(image, e, zoomRatio, overlay);
      overlay.onmouseleave = dismissOverlay;
    };
  });
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    if (image.dataset.lightboxZoomBound) return;
    image.dataset.lightboxZoomBound = 'true';

    const opener = image.closest('.product__modal-opener--image');
    if (!opener) return;

    let hoverOverlay = null;

    opener.addEventListener('mouseenter', (event) => {
      if (hoverOverlay) return;
      const overlayImage = document.createElement('img');
      overlayImage.setAttribute('src', `${image.src}`);
      hoverOverlay = document.createElement('div');
      prepareOverlay(hoverOverlay, overlayImage);
      hoverOverlay.style.pointerEvents = 'none';
      positionOverlay(image, event, zoomRatio, hoverOverlay);

      overlayImage.onload = () => {
        image.parentElement.insertBefore(hoverOverlay, image);
      };
    });

    opener.addEventListener('mousemove', (event) => {
      if (!hoverOverlay || !hoverOverlay.parentElement) return;
      positionOverlay(image, event, zoomRatio, hoverOverlay);
    });

    opener.addEventListener('mouseleave', () => {
      if (hoverOverlay) {
        hoverOverlay.remove();
        hoverOverlay = null;
      }
    });
  });
}

enableZoomOnClick(2);
enableZoomOnHover(2);
